import { Divider, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { CartProductCode } from '@ace-clublabs/common-membership-api-types';
import { ReviewItem } from './ReviewItem';
import { useContext } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';
import { associateTypeMap } from '../../utils/stringHelper';

export const ReviewFamilyMemberSection = () => {
  const { sessionData } = useContext(MembershipAppStateContext);

  const familyUpgradeCost = sessionData?.priceCart?.items?.find((item) => item.code === CartProductCode.FAMILYCOST);

  return (
    <Stack>
      <Stack direction="column" className="family-member-section-container" width="100%" gap="0.5rem">
        <Typography variant="b3Regular" className="family-member-section-title">
          Family members
        </Typography>
        {sessionData.formData.associates?.map((associate, index) => {
          const associatePriceCart = sessionData.priceCart?.items?.find((a) => a.id === associate.virtualId);
          return (
            <ReviewItem
              key={index}
              title={`• ${associate.firstName} ${associate.lastName}`}
              subtitle={associateTypeMap[associate.roleType].toLowerCase()}
              {...associatePriceCart!}
              mask={true}
              className={`associate-item-${index}`}
            />
          );
        })}
        {familyUpgradeCost && (
          <ReviewItem className="family-upgrade" title="Family upgrade fee" {...familyUpgradeCost!} />
        )}
      </Stack>
      <Divider variant="fullWidth" sx={{ margin: '1rem 0' }} />
    </Stack>
  );
};
